import styled from "styled-components";

export const DataContent = styled.div`
  margin: 0 auto;
  justify-content: center;
  display: flex;
  text-align: left;
  padding: 28px 32px;
  width: 100%;
  gap: 12px;
  background-color: white;
  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
  border-radius: 4px;
  flex-direction: column;
  margin-bottom: 20px;
  hr {
    margin-top: 14px;
    height: 1.6px;
    width: auto;
    background-color: #cecece;
    border: 0px;
  }
  h3 {
    font-size: 22px;
    font-weight: 500;
  }
  p {
    margin-top: 12px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4;
  }
  span {
    color: #444;
    font-size: 16px;
    line-height: 1.5;
  }
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(200px, 240px) 1fr;
  gap: 12px 20px;
  align-items: center;
  margin-top: 4px;

  p {
    margin: 0;
    color: #666;
  }

  span {
    margin: 0;
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    gap: 10px 0;
  }
`;

export const Actions = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 20px;
`;
